<template>
  <page>
    <page-poster
      :headline="$t('uninstall.extension.headline')"
      :paragraphs="[$t('uninstall.extension.paragraph-1'), $t('uninstall.extension.paragraph-2')]"
      class="uninstall-extension-poster"
    />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePoster from '@/components/common/PagePoster.vue';
import { sentUserContext } from '../services/network/digitalFingerprint';
import { isExtensionInstalled } from '../services/extension';

export default {
  components: {
    Page,
    PagePoster,
  },
  async mounted() {
    const installed = await isExtensionInstalled();
    if (!installed) {
      sentUserContext({
        trigger: 'UNINSTALLED',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.uninstall-extension-poster {
  padding: 220px 0;
}
</style>
